import { Component, Input, inject } from '@angular/core';
import { Clipboard } from '@angular/cdk/clipboard';
import { ChatMessage, ChatSessionService, PendingAction } from '../../services/chat-session.service';

@Component({
  selector: 'app-chat-message',
  templateUrl: './chat-message.component.html',
  styleUrls: ['./chat-message.component.scss']
})
export class ChatMessageComponent {
  @Input({ required: true }) message!: ChatMessage;

  session = inject(ChatSessionService);
  private clipboard = inject(Clipboard);
  copied = false;

  copy() {
    this.clipboard.copy(this.message.text);
    this.copied = true;
    setTimeout(() => (this.copied = false), 1500);
  }

  confirm(action: PendingAction) {
    this.session.confirm(this.message, action);
  }

  dismiss(action: PendingAction) {
    this.session.dismiss(this.message, action);
  }

  trackAction(_: number, action: PendingAction) {
    return action.pendingActionId;
  }
}
